import type { Order } from '@/types/order';

/**
 * An edit that takes a multi-box order down to one box must send that one box:
 * an absent `boxes` means "keep the saved boxes" to the backend.
 */
export const withOneBoxCollapse = (payload: Order, originalBoxCount: number): Order =>
  originalBoxCount >= 2 && !payload.boxes
    ? { ...payload, boxes: [{ size: String(payload.size) }] }
    : payload;

/** Preview and carrier lookups only take a real multi-box list (2+). */
export const multiBoxListOrNone = (boxes?: Order['boxes']) =>
  Array.isArray(boxes) && boxes.length >= 2 ? boxes : undefined;
